import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";

import {
  downloadWricefClientReport,
  getWricefClientReportPreview,
  type WricefClientReportOptions,
} from "@/api/wricef-catalog";
import type { WricefCatalogQuery } from "@/types/wricef";

/*
  O relatório para o cliente no Catálogo WRICEF (#1620, EF-ARCH-002).

  Arquivo próprio pelo mesmo motivo de `useWricefUsageRule.ts`: os testes da aba
  mockam `useWricefCatalog.ts` inteiro, e um hook novo lá dentro sumiria nesses
  mocks. A chave fica sob o prefixo da lista (`["wricef-catalog", projeto]`), para
  que gravar uma decisão, que invalida a lista, invalide a prévia junto.
*/

export const wricefClientReportKey = (
  projectId: string,
  query: WricefCatalogQuery,
  options: WricefClientReportOptions,
) => ["wricef-catalog", projectId, "_client_report", query, options] as const;

/**
 * A prévia da janela, lida só com ela aberta. Ao trocar o escopo, a prévia
 * anterior fica na tela até a nova chegar, em vez de a janela piscar vazia.
 */
export function useWricefClientReportPreview(
  projectId: string | undefined,
  query: WricefCatalogQuery,
  options: WricefClientReportOptions,
) {
  return useQuery({
    queryKey: wricefClientReportKey(projectId ?? "", query, options),
    queryFn: () => getWricefClientReportPreview(projectId!, query, options),
    enabled: !!projectId,
    staleTime: 0,
    placeholderData: keepPreviousData,
  });
}

/** Gera e baixa o .xlsx com as opções da janela. */
export function useDownloadWricefClientReport(
  projectId: string | undefined,
  query: WricefCatalogQuery,
  options: WricefClientReportOptions,
) {
  return useMutation({
    mutationFn: () => downloadWricefClientReport(projectId!, query, options),
  });
}
